export function validGreaterThan(field) {
    return (
        parseFloat(field.value) >
        parseFloat(field.getAttribute("data-greater-than"))
    );
}
